import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstcf0: [],
		cf0: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {

	},
	mutations: {
		set(state, cf0){
			state.cf0 = cf0
			if (cf0)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cf0 = null
		},
		setParamsDataTable(state, payload){
			state.lstcf0 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, cf0cliente){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Customer/BillingAddress/Find/${cf0cliente}`)
			.then(response => {
				let cf0 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", cf0)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Customer/BillingAddress/Insert", store.state.cf0 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/enderecos-cobranca")
				store.state.cf0 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Customer/BillingAddress/Update", store.state.cf0 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/enderecos-cobranca")
				store.state.cf0 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Customer/BillingAddress/Delete/${store.state.cf0.cf0cliente}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/enderecos-cobranca/")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Customer/BillingAddress/FindList")
			.then(response => {
				let lstcf0 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstcf0 = lstcf0
				store.state.hasNext = lstcf0.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstcf0 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Customer/BillingAddress/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstcf0 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}
